<mat-toolbar>
  <a (click)="toggleMenu()" id="logo">
    <img alt="Logo" src="./assets/img/logo-white.svg">
  </a>

  <button [matMenuTriggerFor]="menu" class="button-user" mat-flat-button>
    <mat-icon>account_box</mat-icon>
    <span>
      Bienvenue,<br>
      {{ user.firstName }}
    </span>
  </button>

  <a class="ml1" href="https://client.grooupee.fr" mat-flat-button target="_blank">
    Site internet Grooupee
  </a>
  <mat-menu #menu="matMenu">
    <button mat-menu-item routerLink="/profile">
      <mat-icon>settings</mat-icon>
      <span>Mes informations</span>
    </button>
    <button (click)="logout()" mat-menu-item>
      <mat-icon>logout</mat-icon>
      <span>Déconnexion</span>
    </button>
  </mat-menu>
</mat-toolbar>


